import { render, staticRenderFns } from "./IpForm.vue?vue&type=template&id=4f0ca6d4&scoped=true&"
import script from "./IpForm.vue?vue&type=script&lang=js&"
export * from "./IpForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0ca6d4",
  null
  
)

export default component.exports